import React from "react";
import "./css/TechInternSection.css";

const TechInternsSection = () => {
  return (
    <div className="tech-interns-section">
      <p className="tech-interns-title">Tech Interns</p>
      {/* <img src="/Interns.png" alt="Tech Interns" /> */}
    </div>
  );
};

export default TechInternsSection;
